module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/2x2-flatpack-73c4bce54866d7b190b017f2fef4d42c.png";